module.exports = __webpack_public_path__ + "img/business-pic.3bd093d6.png";